import { render, staticRenderFns } from "./NotesTab.vue?vue&type=template&id=e02278da&scoped=true&"
import script from "./NotesTab.vue?vue&type=script&lang=js&"
export * from "./NotesTab.vue?vue&type=script&lang=js&"
import style0 from "./NotesTab.vue?vue&type=style&index=0&id=e02278da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e02278da",
  null
  
)

export default component.exports